import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({ 
  baseURL: API_BASE_URL, 
  headers: { 'Content-Type': 'application/json' } 
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getEmailStats: (days = 30) => api.get(`/dashboard/email-stats?days=${days}`),
};

export const contactsApi = {
  list: (params) => api.get('/contacts', { params }),
  get: (id) => api.get(`/contacts/${id}`),
  create: (data) => api.post('/contacts', data),
  update: (id, data) => api.patch(`/contacts/${id}`, data),
  delete: (id) => api.delete(`/contacts/${id}`),
  unsubscribe: (id) => api.post(`/contacts/${id}/unsubscribe`),
};

export const campaignsApi = {
  list: (params) => api.get('/campaigns', { params }),
  get: (id) => api.get(`/campaigns/${id}`),
  create: (data) => api.post('/campaigns', data),
  update: (id, data) => api.patch(`/campaigns/${id}`, data),
  delete: (id) => api.delete(`/campaigns/${id}`),
  start: (id) => api.post(`/campaigns/${id}/start`),
  pause: (id) => api.post(`/campaigns/${id}/pause`),
  cancel: (id) => api.post(`/campaigns/${id}/cancel`),
  schedule: (id, scheduledAt) => api.post(`/campaigns/${id}/schedule`, null, { params: { scheduled_at: scheduledAt } }),
  getStats: (id) => api.get(`/campaigns/${id}/stats`),
  getRecipients: (id) => api.get(`/campaigns/${id}/recipients`),
};

export const templatesApi = {
  list: (params) => api.get('/templates', { params }),
  get: (id) => api.get(`/templates/${id}`),
  create: (data) => api.post('/templates', data),
  update: (id, data) => api.patch(`/templates/${id}`, data),
  delete: (id) => api.delete(`/templates/${id}`),
  preview: (id, variables) => api.post(`/templates/${id}/preview`, { variables }),
};

export const segmentsApi = {
  list: (params) => api.get('/segments', { params }),
  get: (id) => api.get(`/segments/${id}`),
  create: (data) => api.post('/segments', data),
  update: (id, data) => api.patch(`/segments/${id}`, data),
  delete: (id) => api.delete(`/segments/${id}`),
  recalculate: (id) => api.post(`/segments/${id}/recalculate`),
};

export const syncApi = {
  getSettings: () => api.get('/sync/settings'),
  updateSettings: (platform, data) => api.patch(`/sync/settings/${platform}`, data),
  syncNow: (platform) => api.post(`/sync/trigger/${platform}`),
  syncAll: () => api.post('/sync/trigger-all'),
  getLogs: (params) => api.get('/sync/logs', { params }),
  getStatus: () => api.get('/sync/status'),
};

export default api;
